import InputPassword from '../InputPassword';
import isEmpty from 'is-empty';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { InputTextProps } from '../InputText/InputText';
import { useSession } from '@hooks';

interface InputPasswordConfirmProps extends React.InputHTMLAttributes<HTMLInputElement>, InputTextProps {
  passwordToCheck?: string
  showConfirmation?: boolean,
  showViewPassword?: boolean
};

const languagesVarsCodes = [
  "LANG_neobooking_password_confirm_valid", //les mots de passe correspondent
  "LANG_neobooking_password_confirm_invalid", //les mots de passe ne correspondent pas
]

const InputPasswordConfirm: React.FC<InputPasswordConfirmProps> = ({ passwordToCheck, showConfirmation, showViewPassword = true, ...props }) => {

  /* Hooks */
  const { getLanguageVarValue } = useSession();

  /* State */
  const [valid, setValid] = useState(props.value == passwordToCheck)

  useEffect(() => {
    setValid(props.value == passwordToCheck)
  }, [passwordToCheck, props.value])

  return <>
    <InputPassword showViewPassword={showViewPassword} showStrength={false} {...props} />
    {
      (showConfirmation && !isEmpty(props.value)) && <>
        <div className="tw-relative">
          <div className="tw-flex tw-items-center" style={{ margin: "5px 0px 0px" }}>
            <div className={valid ? "tw-bg-green-500" : "tw-bg-red-500"} style={{ flexBasis: "0px", flexGrow: "1", position: "relative", maxWidth: "100%", width: "100%", height: "2px" }}></div>
          </div>
          <p className={valid ? "tw-text-green-500" : "tw-text-red-500"} style={{ margin: "5px 0px 0px", fontSize: "14px", textAlign: "right" }}>
            {
              valid ? getLanguageVarValue("LANG_neobooking_password_confirm_valid") : getLanguageVarValue("LANG_neobooking_password_confirm_invalid")
            }
          </p>
        </div>
      </>
    }
  </>;
};

InputPasswordConfirm.propTypes = {
  passwordToCheck: PropTypes.string,
  showConfirmation: PropTypes.bool,
  showViewPassword: PropTypes.bool
};

export default InputPasswordConfirm;
